import {
  DropdownMenu,
  DropdownMenuItem,
  Stack,
  Title,
  FontAwesomeIcon,
  Box,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface BackgroundUploadProps {
  backgroundUrl?: string;
  onUpload: () => void;
  onDelete: () => void;
  title: string;
}

export const BackgroundUpload = ({
  backgroundUrl,
  onUpload,
  onDelete,
  title,
}: BackgroundUploadProps) => {
  const { t } = useTranslation();

  const handleUpload = () => {
    onUpload();
  };

  return (
    <Stack>
      <Title size="xs" paddingBottom paddingTop header={title} />
      <Stack className="bg-dark/5 rounded-xs">
        <DropdownMenu
          trigger={
            <Box className="relative w-full h-48 group cursor-pointer overflow-hidden rounded-sm">
              {backgroundUrl && (
                <div
                  className="w-full h-full bg-cover bg-center"
                  style={{ backgroundImage: `url(${backgroundUrl})` }}
                />
              )}
              <Box className="bg-dark/20 opacity-0 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                <FontAwesomeIcon icon="fa-light fa-image" className={"text-[40px] text-light"} />
              </Box>
            </Box>
          }
        >
          <DropdownMenuItem
            leftIcon={<FontAwesomeIcon icon="fa-light fa-image" />}
            onClick={handleUpload}
            title={t("common:upload_new")}
          />
          <DropdownMenuItem
            leftIcon={<FontAwesomeIcon icon="fa-light fa-trash" />}
            onClick={onDelete}
            variant={"menuDanger"}
            title={t("common:delete")}
          />
        </DropdownMenu>
      </Stack>
    </Stack>
  );
};
